import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class ProjectService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.MANAGEMENT_URL = '/api/management';
        this.PROJECT = '/api/project';

        this.GET_BY_ID = '/{id}';
        this.GET_DELETED_BY_ID = '/deleted/{id}';

        this.GET_LIST_IN_ORG = '/list/org/{orgId}';
        this.GET_PROJECT_LIST_BY_USER = '/list/project/user/{userId}';
        this.GET_USER_LIST_BY_PROJECT = '/list/user/project/{projectId}';
        this.GET_SIMPLE_USER_LIST_BY_PROJECT = '/simple/list/user/project/{projectId}';
        this.GET_ASSIGNEE_USER_LIST_BY_PROJECT = '/list/assignee/user/project/{projectId}';
        this.GET_SIMPLE_ASSIGNEE_USER_LIST_BY_PROJECT = "/simple/list/assignee/user/project/{projectId}";
        this.GET_RELATED_LIST_BY_USER = '/list/related/user/{assigneeUserId}';
        this.GET_LIST_BY_USER_IN_PERIOD = '/list/user/{assigneeUserId}/from/{startTime}/to/{endTime}';
//        this.GET_PROJECT_FILES = "/list/project/files";
//        this.GET_PROJECT_FILES_FOLDERS = "/list/project/files/folders";

        this.GET_LIST_BY_STATUS_IN_PROJECT = '/list/status/{status}/project/{projectId}';
        this.GET_LIST_BY_STATUS_IN_PARENT = '/list/status/{status}/{parentType}/{parentId}';
        this.GET_USER_PERMISSION_LIST_BY_PROJECT = '/list/permission/user/project/{projectId}';
        this.GET_TEAM_PERMISSION_LIST_BY_PROJECT = '/list/permission/team/project/{projectId}';
        this.SEARCH_ISSUES_BY_KEYWORD_FOR_USER = '/search/issues/user/{userId}/keyword/{keyword}';
        this.COUNT_OF_SEARCH_ISSUES_BY_KEYWORD_FOR_USER = '/search/count/issues/user/{userId}/keyword/{keyword}';

        this.COUNT_OF_SEARCH_ISSUES_BY_KEYWORD_FOR_USER = '/search/count/issues/user/{userId}/keyword/{keyword}';

        this.ADD_CONTRIBUTOR = '/add/contributor';
        this.UPDATE_CONTRIBUTOR = '/update/contributor';
        this.REMOVE_CONTRIBUTOR = '/remove/contributor';

    }

    /*
     * REST Protocols for Projects.
     *
     * GET Requests:
     *     1) getProject - GET By ID
     *     2) getDeletedProject - GET By ID
     *     3) getProjectListInTeamInOrg - GET LIST By TEAM -> ORG
     *     4) getProjectListForUser - GET LIST By USER -> ORG
     *     5) getProjectListForUserInPeriod GET LIST By USER -> START-TIME <-> END-TIME
     *     6) searchIssuesByKeywordForUser - GET ISSUE LIST BY KEYWORD For USER
     *
     * POST Requests:
     *     1) createProject - CREATE Project
     *
     * PUT Requests:
     *     1) updateProject - UPDATE Project
     *
     * DELETE Requests:
     *     1) deleteProject - DELETE Project
     */

    async getProjectFetch(id) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }


    async getProject(id) {
        let projectCacheObj = localStorage.getItem('projectCache');
        if(!!projectCacheObj) {
            projectCacheObj = JSON.parse(projectCacheObj);
            let projectObj = projectCacheObj[id];
            if(!!projectObj) {
                projectObj = {
                    'body': JSON.stringify(projectObj)
                }
                return projectObj;
            }
        } else {
            projectCacheObj = {};
        }
        let projectFetchObj = await this.getProjectFetch(id);
        if(!!projectFetchObj?.body){
            let projectRetObj = JSON.parse(projectFetchObj.body);
            projectCacheObj[id] = projectRetObj;
            localStorage.setItem('projectCache', JSON.stringify(projectCacheObj));
        }
        return projectFetchObj;
    }

    async getProjectForceFetch(id) {
        let projectCacheObj = localStorage.getItem('projectCache');
        if(!!projectCacheObj) {
            projectCacheObj = JSON.parse(projectCacheObj);
        } else {
            projectCacheObj = {};
        }
        let projectFetchObj = await this.getProjectFetch(id);
        if(!!projectFetchObj?.body){
            let projectRetObj = JSON.parse(projectFetchObj.body);
            projectCacheObj[id] = projectRetObj;
            localStorage.setItem('projectCache', JSON.stringify(projectCacheObj));
        }
        return projectFetchObj;
    }

    async getDeletedProject(id) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_DELETED_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListInOrg(orgId) {
        try {
            let accessList = !!localStorage.getItem('activeUserAccessList') ? JSON.parse(localStorage.getItem('activeUserAccessList')) : {};
            if(!!accessList) {
                let projects = !!accessList.projects ? accessList.projects : [];
                let parentId = !!orgId ? JSON.parse(orgId) : 0;
                let parentType = 'org';
                let getProjectsInOrg = projects.filter((item)=> (item.parentId === parentId && item.parentType === parentType) && item);
                return {body: JSON.stringify(getProjectsInOrg)};
            } else {
                return await this.getProjectListInOrgRefetch(orgId);
            }
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListInOrgRefetch(orgId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_LIST_IN_ORG;
            url = url
                .replace('{orgId}', orgId);
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

//    async getFilesListForProject(projectId) {
//        try {
//            let url = window.location.origin + this.PROJECT + this.GET_PROJECT_FILES;
//            const files = await this.fetch(url, {
//                    method: 'GET',
//                    retries: 10,
//                    retryDelay: 200
//                }).then(data => data.json())
//                    .then(data => {
//                        if(data.error !== undefined){
//                            if(data.error === 'Session Expired') {
//                                let userAuthService = new UserAuthService();
//                                userAuthService.logout();
//                            } else {
//                                localStorage.setItem('errorUUID', data.uuid);
//                            }
//                        }
//                        return data;
//                    })
//            return files;
//        } catch (err) {
//            console.log(err);
//        }
//    }

    async getSimpleUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_SIMPLE_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getAssigneeUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_ASSIGNEE_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleAssigneeUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_SIMPLE_ASSIGNEE_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getUserPermissionListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_USER_PERMISSION_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getTeamPermissionListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_TEAM_PERMISSION_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListForUser(userId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_PROJECT_LIST_BY_USER;
            url = url
                .replace('{userId}', userId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getRelatedProjectListForUser(assigneeUserId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_RELATED_LIST_BY_USER;
            url = url
                .replace('{assigneeUserId}', assigneeUserId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListForUserInPeriod(assigneeUserId, startTime, endTime) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_LIST_BY_USER_IN_PERIOD;
            url = url
                .replace('{assigneeUserId}', assigneeUserId)
                .replace('{startTime}', startTime)
                .replace('{endTime}', endTime)
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async searchIssuesByKeywordForUser(userId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.SEARCH_ISSUES_BY_KEYWORD_FOR_USER;
        url = url
            .replace('{userId}', userId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async countForSearchIssuesByKeywordForUser(userId, keyword){
        let url = window.location.origin + this.MANAGEMENT_URL + this.COUNT_OF_SEARCH_ISSUES_BY_KEYWORD_FOR_USER;
        url = url
            .replace('{userId}', userId)
            .replace('{keyword}', keyword);
        try {
            return await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async addContributorToProject(addMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT + this.ADD_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(addMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateContributorPermissionInProject(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT + this.UPDATE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async removeContributorPermissionFromProject(removeMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT + this.REMOVE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(removeMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createProject(project) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(project)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateProject(project) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(project)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteProject(project){
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT;
        try {
            const projectDataRet = await this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(project)
            }).then((data) => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }
}

export default ProjectService;
